define('container/argResolvers/LoggerArgResolver',[],function() {

    'use strict';

    function LoggerArgResolver(loggerConstructorServiceId) {
        this.loggerConstructorServiceId = loggerConstructorServiceId;
    }

    LoggerArgResolver.prototype.canResolveArg = function(argDefinition) {
        return argDefinition.substr(0, 3) === 'LOG';
    };

    LoggerArgResolver.prototype.resolveArg = function(argDefinition, extensionApi) {

        var parts = argDefinition.substring(1).split('.'),
            loggerMethodName = parts[1];

        return extensionApi.container.get(this.loggerConstructorServiceId).then(function(Logger) {

            if (loggerMethodName) {
                return (new Logger(extensionApi.serviceId))[loggerMethodName];
            }

            return new Logger(extensionApi.serviceId);
        });
    };

    return LoggerArgResolver;
});

